import { useState } from "react";
import { FaCheck } from "react-icons/fa";
import { FaRegEdit, FaTrash } from "react-icons/fa";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import EditIdeaModal from '../EditIdeaModal';
import './styles.css';

export default function IdeaCard({ 
    id,
    title,
    description,
    isSelected = false,
    disabled = false,
    onSelect,
    onEdit,
    onEditConfirm,
    onDelete,
    className = ""
}) {
    const [isExpanded, setIsExpanded] = useState(false);
    const [isHovered, setIsHovered] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);

    const handleRadioClick = (e) => {
        e.stopPropagation();
        if (!disabled && onSelect) {
            onSelect(id);
        }
    };

    const handleExpandClick = (e) => {
        e.stopPropagation();
        setIsExpanded(!isExpanded);
    };

    const handleEdit = (e) => {
        e.stopPropagation();
        if (!disabled) {
            setShowEditModal(true);
        }
    };

    const handleDelete = (e) => {
        e.stopPropagation();
        if (!disabled && onDelete) {
            onDelete(id);
        }
    };

    const handleMouseEnter = () => {
        setIsHovered(true);
    };

    const handleMouseLeave = () => {
        setIsHovered(false);
    };

    const handleEditConfirm = (editedIdea) => {
        if (onEditConfirm) {
            onEditConfirm(editedIdea);
        }
        setShowEditModal(false);
    };

    const handleEditCancel = () => {
        setShowEditModal(false);
    };

    const getTruncatedTitle = (text, maxLength = 28) => {
        if (text.length <= maxLength) return text;
        return text.substring(0, maxLength) + "...";
    };

    return (
        <div 
            className={`idea-card ${isSelected ? 'selected' : ''} ${disabled ? 'disabled' : ''} ${isExpanded ? 'expanded' : ''} ${className}`}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            role="button"
            tabIndex={disabled ? -1 : 0}
            aria-pressed={isSelected}
            aria-disabled={disabled}
            aria-expanded={isExpanded}
        >
            <div className="idea-card-actions">
                <button
                    className="idea-action-btn idea-edit-btn"
                    onClick={handleEdit}
                    title="Editar ideia"
                    aria-label="Editar ideia"
                >
                    <FaRegEdit size={14} />
                </button>
                <button
                    className="idea-action-btn idea-delete-btn"
                    onClick={handleDelete}
                    title="Excluir ideia"
                    aria-label="Excluir ideia"
                >
                    <FaTrash size={14} />
                </button>
                <button
                    className="idea-action-btn expand-button"
                    onClick={handleExpandClick}
                    title={isExpanded ? "Recolher" : "Expandir"}
                    aria-label={isExpanded ? "Recolher" : "Expandir"}
                >
                    {isExpanded ? <FaChevronUp size={14} /> : <FaChevronDown size={14} />}
                </button>
            </div>

            <div className="idea-card-content">
                <div className="idea-card-header">
                    <div 
                        className="idea-card-checkbox"
                        onClick={handleRadioClick}
                        role="button"
                        tabIndex={disabled ? -1 : 0}
                        aria-label="Selecionar ideia"
                    >
                        {isSelected && <FaCheck size={14} />}
                    </div>
                    <p className="idea-card-title">
                        {isHovered ? getTruncatedTitle(title) : title}
                    </p>
                </div>

                {isExpanded && (
                    <div className="idea-card-description">
                        <p>{description}</p>
                    </div>
                )}
            </div>

            <EditIdeaModal
                show={showEditModal}
                onHide={handleEditCancel}
                idea={{ id, title, description }}
                onConfirm={handleEditConfirm}
            />
        </div>
    );
}